import React, { useContext } from "react"
import { Link } from "gatsby"
import { FormatDate } from "../../lib/site-functions"
import { BiInfoCircle } from "react-icons/bi"
import SiteContext from "../../context/site-context"

export default function NewsItem({
  id,
  href,
  item,
  itemCol = "news-item col-sm-6 col-md-4",
  allowed,
  loggedIn,
}) {
  const {
    showLoginSetState,
    setLoginRedirect,
    setSelectedItemTariff,
  } = useContext(SiteContext)

  function showLoginOnClick(event) {
    if (!allowed && !loggedIn) {
      event.preventDefault()
      setSelectedItemTariff(item.tarifs)
      setLoginRedirect({ redirect: false, path: "/news-detail/" + id })
      showLoginSetState(true)
    }
  }

  return (
    <div className={itemCol} key={id}>
      <div className="element">
        <div className="img-wrapper">
          <Link to={href} onClick={showLoginOnClick}>
            <div style={{ overflow: allowed && "hidden" }}>
              <div
                className={!allowed ? "tooltip" : ""}
                data-direction="bottom"
              >
                <div className="tooltip__initiator">
                  {item.photo === null ? (
                    <div style={{ overflow: "hidden" }}>
                      <div
                        className="element-img"
                        style={{
                          width: "100%",
                          height: "160px",
                          background:
                            "url(/images/site/camera.png) 50% 100% no-repeat",
                          backgroundSize: "contain",
                          opacity: allowed ? 1 : 0.7,
                          textAlign: "center",
                        }}
                      >
                        {!allowed && <BiInfoCircle className="info-icon" />}
                      </div>
                    </div>
                  ) : (
                    <div
                      className={
                        allowed ? "element-img allowed" : "element-img"
                      }
                      style={{
                        width: "100%",
                        height: "160px",
                        background: "url(" + item.photo + ") 50% 50% no-repeat",
                        backgroundSize: "cover",
                        opacity: allowed ? 1 : 0.7,
                        textAlign: "center",
                      }}
                    >
                      {!allowed && <BiInfoCircle className="info-icon" />}
                    </div>
                  )}
                </div>
                {!allowed && (
                  <div className="tooltip__item">
                    {loggedIn ? (
                      <div>
                        Данная новость доступна только для тарифов: <br />
                        <ul>
                          {item.tarifs.map(object => {
                            return (
                              <li key={object.id}>
                                <b>{object.title}</b>
                              </li>
                            )
                          })}
                        </ul>
                      </div>
                    ) : (
                      <div>
                        Войдите в личный кабинет, чтобы просмотреть новость.
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </Link>
        </div>
        <div className="push15" />
        <div className="news-date">{FormatDate(item.created_at)}</div>
        <div className="push5" />
        <div className="title bold f16">
          <Link
            to={href}
            onClick={showLoginOnClick}
            className="black decoration-none"
          >
            {item.title}
          </Link>
        </div>
        <div className="push10" />
        <div
          className="text f13"
          dangerouslySetInnerHTML={{ __html: item.preview + "&#8230;" }}
        />
        <div className="push10" />
        {allowed && (
          <Link to={href} className="f13 bold">
            Подробнее
          </Link>
        )}
      </div>
    </div>
  )
}
